import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Snackbar,
  Alert,
  Stack,
  Modal,
  Button,
  Card,
  CardContent,

} from "@mui/material";
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { investorApi } from "../../api/api";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import GradientButton from "../common/GradiantButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SelectedSiteVisit from "./SelectedSiteVisit";

const SiteVisit = () => {
  const userId = useSelector((state) => state.user.userId);
  const location = useLocation();
  const propertyData = location.state?.propertyData;
  const type = location.state?.type;
  const data = location.state?.data;
  const selectedFlat = location.state?.selectedFlat;
    const selectedFlatId = location.state?.selectedFlatId;
  const navigate = useNavigate();

  // console.log(data);
  // debugger
  const [flatData, setflatData] = useState(null)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  useEffect(() => {
    //  Safety checks
    if (!data?.apartment?.Id || !selectedFlat) return;

    const fetchSelectedFlat = async () => {
      try {
        const response = await investorApi.getFlatById(
          data.apartment.Id,
          selectedFlat
        );
        setflatData(response.data.data);
        // ✅ If you want to store the response
        // setFlatDetails(response.data.data);

      } catch (error) {
        console.error("Error fetching flat:", error);
      }
    };

    fetchSelectedFlat();
  }, [data?.apartment?.Id, selectedFlat]);


  // Get tomorrow
  let defaultDate = dayjs().add(1, 'day');
  // If tomorrow is Sunday (0), skip to Monday
  if (defaultDate.day() === 0) {
    defaultDate = defaultDate.add(1, 'day');
  }


  // Default time = 9 AM
  const defaultTime = dayjs().hour(9).minute(0).second(0);
  const [selectedDate, setSelectedDate] = useState(defaultDate);
  const [selectedTime, setSelectedTime] = useState(defaultTime);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDateChange = (newDate) => setSelectedDate(newDate);
  const handleTimeChange = (newTime) => setSelectedTime(newTime);

  const getCombinedDateTime = () =>
    selectedDate
      .hour(selectedTime.hour())
      .minute(selectedTime.minute())
      .second(0);

  const getFormattedDateTime = (d) => d.format("DD MMM YYYY HH:mm");

  const handleScheduleClick = () => {
    const combinedDateTime = getCombinedDateTime();
    const now = dayjs();

    // Validation checks
    const isSunday = combinedDateTime.day() === 0;
    const isBeforeToday = combinedDateTime.isBefore(now, "day");
    const hour = combinedDateTime.hour();

    if (isSunday) {
      setSnackbar({
        open: true,
        message: "Visits cannot be scheduled on Sundays.",
        severity: "error",
      });
      return;
    }

    if (isBeforeToday) {
      setSnackbar({
        open: true,
        message: "You cannot select a past date.",
        severity: "error",
      });
      return;
    }

    if (hour < 9 || hour >= 18) {
      setSnackbar({
        open: true,
        message: "Visit time must be between 9:00 AM and 6:00 PM.",
        severity: "error",
      });
      return;
    }

    // Open confirmation modal if validation passes
    setConfirmationModal(true);
  };

  const handleConfirmVisit = async () => {
    setLoading(true);

    try {
      const combinedDateTime = getCombinedDateTime();

      console.log(selectedFlatId);
      debugger
      // Base payload
      const payload = {
        user_id: userId,
        Flat_id: selectedFlatId,
        visit_datetime: getFormattedDateTime(combinedDateTime),
      };

      // Decide what ID to send
      if (data?.apartment?.PropertyType === 3) {
        payload.apartment_id = data.apartment.Id;
      } else {
        payload.property_id = propertyData;
      }


      await investorApi.addSiteVisit(payload);

      setSnackbar({
        open: true,
        message: "Visit scheduled successfully!",
        severity: "success",
      });

      setConfirmationModal(false);

      setTimeout(() => {
        navigate(-1);
      }, 1500);

    } catch (error) {
      console.error("Schedule visit error:", error);

      setSnackbar({
        open: true,
        message: "Failed to schedule visit.",
        severity: "error",
      });

    } finally {
      setLoading(false);
    }
  };


  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleCloseModal = () => {
    setConfirmationModal(false);
  };

  // Modal style
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { sm: 400, xs: 300 },
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          maxWidth: 900,
          mx: "auto",
          mt: 4,
          p: { xs: 2, sm: 3 },
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            Back
          </Button>
        </Box>
        {/* PAGE TITLE */}
        <Typography variant="h4" fontWeight={700} align="center">
          Schedule Site Visit
        </Typography>
        <Typography
          variant="body1"
          align="center"
          color="text.secondary"
          mb={4}
        >
          Review flat details and choose your visit date & time
        </Typography>

        {/*  TOP VIEW : SELECTED PROPERTY DETAILS */}
        <Box mb={4}>
          <SelectedSiteVisit flatData={flatData} data={data} />
        </Box>

        {/*  BOTTOM VIEW : DATE & TIME SELECTION */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Stack spacing={3}>
              <Typography variant="h6" fontWeight={600}>
                Select Visit Date & Time
              </Typography>

              {/* Date Picker */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <CalendarMonthIcon color="primary" />
                <DatePicker
                  label="Select Date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  disablePast                         // ❌ disables ONLY past dates
                  shouldDisableDate={(date) => date.day() === 0} // ❌ disables Sunday
                  slotProps={{ textField: { fullWidth: true } }}
                />

              </Box>

              {/* Time Picker */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <AccessTimeIcon color="primary" />
                <TimePicker
                  label="Select Time"
                  value={selectedTime}
                  onChange={handleTimeChange}
                  minutesStep={15}
                  minTime={
                    selectedDate.isSame(dayjs(), "day")
                      ? dayjs() // today → current time
                      : dayjs(selectedDate).hour(9).minute(0)
                  }
                  maxTime={dayjs(selectedDate).hour(18).minute(0)}
                  slotProps={{ textField: { fullWidth: true } }}
                />

              </Box>

              {/* CTA BUTTON */}
              <GradientButton
                text="Schedule Visit"
                onClick={handleScheduleClick}
                width="100%"
              />
            </Stack>
          </CardContent>
        </Card>

        {/* CONFIRMATION MODAL */}
        <Modal open={confirmationModal} onClose={handleCloseModal}>
          <Box sx={modalStyle}>
            <Box textAlign="center" mb={3}>
              <CheckCircleIcon
                sx={{ fontSize: 60, color: "primary.main", mb: 1 }}
              />
              <Typography variant="h5" fontWeight={600}>
                Confirm Site Visit
              </Typography>
              <Typography color="text.secondary">
                Please confirm your visit details
              </Typography>
            </Box>

            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography>
                  <strong>Date:</strong>{" "}
                  {selectedDate.format("DD MMMM YYYY")}
                </Typography>
                <Typography>
                  <strong>Day:</strong> {selectedDate.format("dddd")}
                </Typography>
                <Typography>
                  <strong>Time:</strong>{" "}
                  {selectedTime.format("hh:mm A")}
                </Typography>
              </CardContent>
            </Card>

            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                fullWidth
                onClick={handleCloseModal}
                disabled={loading}
              >
                Cancel
              </Button>
              <GradientButton
                text={loading ? "Scheduling..." : "Confirm Visit"}
                onClick={handleConfirmVisit}
                width="100%"
                disabled={loading}
              />
            </Stack>
          </Box>
        </Modal>

        {/* SNACKBAR */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            severity={snackbar.severity}
            onClose={handleCloseSnackbar}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );

};

export default SiteVisit;